(() => {
  'use strict';
  if (customElements.get('shop-the-look-modal')) return;

  const SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  const SWIPER_JS  = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';

  let swiperReady = null;
  function ensureSwiper() {
    if (swiperReady) return swiperReady;
    if (window.Swiper) { swiperReady = Promise.resolve(); return swiperReady; }
    swiperReady = new Promise(resolve => {
      const l = document.createElement('link'); l.rel='stylesheet'; l.href=SWIPER_CSS;
      document.head.appendChild(l);
      const s = document.createElement('script'); s.src=SWIPER_JS;
      s.onload=()=>resolve(); s.onerror=()=>resolve();
      document.body.appendChild(s);
    });
    return swiperReady;
  }

  class ShopTheLookModal extends HTMLElement {
    constructor() { super(); this._swiper = null; this._open = false; }

    connectedCallback() {
      // Event delegation — no DOM manipulation needed
      this._onClick = this._onClick.bind(this);
      document.addEventListener('click', this._onClick);
      document.addEventListener('keydown', e => { if (e.key==='Escape'&&this._open) this.close(); });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onClick);
    }

    _onClick(e) {
      if (e.target.closest('[data-stl-trigger]')) { this.open(); return; }
      if (e.target.closest('[data-stl-close]'))    { this.close(); return; }

      // Mobile size picker: close when clicking outside
      if (!e.target.closest('.stl-card__size-picker') && !e.target.closest('.stl-card__add-btn') && !e.target.closest('.stl-card__notify-btn')) {
        this.querySelectorAll('.stl-card--size-open').forEach(c => c.classList.remove('stl-card--size-open'));
      }

      // Grow Notify Me — direct API call
      const nb = e.target.closest('.stl-card__notify-btn');
      if (nb) { e.preventDefault(); this._onNotify(nb); return; }

      // Color swatch
      const cb = e.target.closest('.stl-card__color-btn');
      if (cb && !cb.disabled) { this._onColorPick(cb); return; }

      // Desktop size buttons
      const sb = e.target.closest('.stl-card__size-btn');
      if (sb) { this._onSize(sb); return; }

      // Mobile size picker buttons
      const spb = e.target.closest('.stl-card__size-picker-btn');
      if (spb && !spb.disabled) { this._onSizePick(spb); return; }

      // Add button — if has size variants, open size picker (all screen sizes)
      const ab = e.target.closest('.stl-card__add-btn');
      if (ab && !ab.disabled) {
        const card = ab.closest('.stl-card');
        if (card && card.dataset.hasVariants) {
          this._openSizePicker(card); return;
        }
        this._onAdd(ab);
      }
    }

    async open() {
      if (this._open) return;
      this._open = true;
      await ensureSwiper();
      this.setAttribute('aria-hidden','false');
      this.classList.add('stl--open');
      document.body.classList.add('stl--body-lock');
      this._initSwiper();
    }

    close() {
      if (!this._open) return;
      this._open = false;
      this.setAttribute('aria-hidden','true');
      this.classList.remove('stl--open', 'stl--ready');
      document.body.classList.remove('stl--body-lock');
      if (this._swiper) { this._swiper.destroy(true,true); this._swiper = null; }
    }

    _initSwiper() {
      if (!window.Swiper || this._swiper) return;
      const c = this.querySelector('.swiper'); if (!c) return;
      try {
        this._swiper = new window.Swiper(c, {
          slidesPerView:2, spaceBetween:8,
          centerInsufficientSlides:true, watchOverflow:true,
          pagination:{ el:this.querySelector('.swiper-pagination'), type:'fraction' },
          navigation:{
            nextEl:this.querySelector('.swiper-button-next'),
            prevEl:this.querySelector('.swiper-button-prev'),
          },
          breakpoints:{
            768:{ slidesPerView:2, slidesPerGroup:2, spaceBetween:12 },
            1024:{ slidesPerView:3, slidesPerGroup:3, spaceBetween:16 },
          },
          on: {
            init: () => setTimeout(() => { this._equalizeHeights(); this.classList.add('stl--ready'); }, 200),
          }
        });
      } catch(_){}
    }

    _equalizeHeights() {
      const slides = this.querySelectorAll('.swiper-slide');
      if (!slides.length) return;
      slides.forEach(s => { s.style.height = 'auto'; });
      void slides[0].offsetHeight;
      let max = 0;
      slides.forEach(s => { if (s.offsetHeight > max) max = s.offsetHeight; });
      if (max > 0) slides.forEach(s => { s.style.height = max + 'px'; });
    }

    _onSize(btn) {
      const g=btn.closest('.stl-card__variant-group'), card=btn.closest('.stl-card');
      if(!g||!card) return;
      g.querySelectorAll('.stl-card__size-btn').forEach(b=>b.classList.remove('stl-card__size-btn--selected'));
      btn.classList.add('stl-card__size-btn--selected');

      // Sold-out size → update notify button's variant
      if (btn.disabled) {
        const notify = card.querySelector('.stl-card__notify-btn');
        if (notify && btn.dataset.variantId) notify.dataset.variantId = btn.dataset.variantId;
        return;
      }

      const add=card.querySelector('.stl-card__add-btn');
      if(add&&btn.dataset.variantId){ add.dataset.variantId=btn.dataset.variantId; add.classList.remove('stl-card__add-btn--added'); add.disabled=false; }
    }

    _onNotify(btn) {
      const productId  = btn.dataset.productId;
      const variantId  = btn.dataset.variantId;
      const handle     = btn.dataset.productHandle;
      if (!productId || !variantId) return;

      // Direct Grow API call — triggers the back-in-stock popup
      const synth = document.createElement('button');
      synth.setAttribute('gw-stock-fulfilled', '');
      synth.dataset.productId = productId;
      synth.dataset.variantId = variantId;
      if (handle) synth.dataset.productHandle = handle;
      synth.style.cssText = 'position:fixed;opacity:0;pointer-events:none;width:0;height:0;';
      document.body.appendChild(synth);

      const fakeEvent = new MouseEvent('click', {bubbles: true, cancelable: true});
      Object.defineProperty(fakeEvent, 'target', {value: synth, writable: false});
      try {
        growConfig.stockWidgetClicked(fakeEvent);
      } catch (_) {
        // Fallback: redirect to product page if Grow not loaded
        const url = btn.dataset.productUrl || (handle ? '/products/' + handle : null);
        if (url) window.open(url, '_blank', 'noopener');
      }
      setTimeout(() => synth.remove(), 500);
    }

    _onColorPick(btn) {
      const card = btn.closest('.stl-card');
      if (!card) return;

      // Update active swatch
      card.querySelectorAll('.stl-card__color-btn').forEach(b => b.classList.remove('stl-card__color-btn--active'));
      btn.classList.add('stl-card__color-btn--active');

      // Update add-to-cart variant
      const ab = card.querySelector('.stl-card__add-btn');
      if (ab && btn.dataset.variantId) {
        ab.dataset.variantId = btn.dataset.variantId;
        ab.disabled = false;
      }

      // Swap card image
      const imgEl = card.querySelector('.stl-card__image img');
      if (imgEl && btn.dataset.img && btn.dataset.img !== '') {
        imgEl.src = btn.dataset.img;
        imgEl.srcset = btn.dataset.img + ' 400w';
      }
    }

    _openSizePicker(card) {
      // Close any other open pickers
      this.querySelectorAll('.stl-card--size-open').forEach(c => {
        if (c !== card) c.classList.remove('stl-card--size-open');
      });

      // Build picker if not already built
      if (!card.querySelector('.stl-card__size-picker')) {
        const variants = card.querySelectorAll('.stl-card__size-btn');
        if (!variants.length) {
          // No size buttons found — just add to cart directly
          const ab = card.querySelector('.stl-card__add-btn');
          if (ab) this._onAdd(ab);
          return;
        }

        const picker = document.createElement('div');
        picker.className = 'stl-card__size-picker';

        const label = document.createElement('span');
        label.className = 'stl-card__size-picker-label';
        label.textContent = 'Select size';
        picker.appendChild(label);

        const opts = document.createElement('div');
        opts.className = 'stl-card__size-picker-options';

        variants.forEach(btn => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'stl-card__size-picker-btn';
          b.textContent = btn.textContent.trim();
          b.dataset.variantId = btn.dataset.variantId;
          if (btn.disabled) b.disabled = true;
          opts.appendChild(b);
        });

        picker.appendChild(opts);

        // Append inside .stl-card__info (which is position:relative on mobile)
        const info = card.querySelector('.stl-card__info');
        if (info) info.appendChild(picker);
      }

      card.classList.toggle('stl-card--size-open');
    }

    _onSizePick(btn) {
      if (btn.disabled) return;
      const card = btn.closest('.stl-card');
      // Set the variant on the add button
      const ab = card && card.querySelector('.stl-card__add-btn');
      if (!ab) return;
      ab.dataset.variantId = btn.dataset.variantId;
      // Close picker
      card.classList.remove('stl-card--size-open');
      // Add to cart
      this._onAdd(ab);
    }

    _onAdd(btn) {
      const vid=btn.dataset.variantId; if(!vid) return;
      btn.disabled=true;
      // Optimistic UI: show checkmark immediately — revert on error
      btn.classList.add('stl-card__add-btn--added');
      const cfg=typeof fetchConfig==='function'?fetchConfig('javascript'):{method:'POST',headers:{'Accept':'application/json'}};
      cfg.headers['X-Requested-With']='XMLHttpRequest'; delete cfg.headers['Content-Type'];
      const fd=new FormData(); fd.append('id',vid); fd.append('quantity','1'); fd.append('properties[_stl]', 'true');
      const cd=document.querySelector('cart-drawer');
      if(cd){ fd.append('sections','cart-drawer'); fd.append('sections_url',location.pathname); }
      cfg.body=fd;
      fetch(window.routes.cart_add_url,cfg).then(r=>r.json()).then(data=>{
        if(data.status){
          // Error: revert optimistic state
          btn.classList.remove('stl-card__add-btn--added');
          btn.disabled=false;
          return;
        }
        // Success: fire cart update event
        if(typeof PUB_SUB_EVENTS!=='undefined'&&typeof publish==='function')
          publish(PUB_SUB_EVENTS.cartUpdate,{source:'shop-the-look',productVariantId:vid,cartData:data});
        // Remove is-empty class — cart-drawer keeps it even after items are added
        ['cart-drawer','#CartDrawer','.drawer-inner','.cart-drawer-footer'].forEach(sel=>{
          document.querySelectorAll(sel).forEach(el=>el.classList.remove('is-empty'));
        });
        setTimeout(()=>{ btn.classList.remove('stl-card__add-btn--added'); btn.disabled=false; this.close(); },1000);
      }).catch(()=>{
        btn.classList.remove('stl-card__add-btn--added');
        btn.disabled=false;
      });
    }
  }

  customElements.define('shop-the-look-modal', ShopTheLookModal);
})();
